export default __webpack_public_path__ + "static/media/one_pager.fda13cee.png";